import React from 'react'
import EDMUploadMemberForm from '../../features/eDMUploadMember/EDMUploadMemberForm'

const EDMUploadMember = () => {
    return (
        <EDMUploadMemberForm />
    )
}

export default EDMUploadMember